import React from 'react';

/**
 * renderTextWithLineBreaks converts line breaks into React paragraph elements
 * @param text - The text to render
 * @param baseClassName - Base CSS class for all paragraphs
 * @param gapClassName - CSS class for spacing between paragraphs (applied to all except the first)
 * @param emptyLineSpaceChar - Character to use to maintain empty lines
 * @returns Array of React elements
 */
export const renderTextWithLineBreaks = (
  text: string | undefined | null,
  baseClassName: string = '',
  gapClassName: string = '',
  emptyLineSpaceChar: string = '\u00A0',
): React.ReactNode | null => {
  if (!text) return null;

  // Split text by line breaks
  const paragraphs = text.split('\n');

  return paragraphs.map((paragraph, index) => (
    <p key={index} className={`${baseClassName} ${index > 0 ? gapClassName : ''} whitespace-pre-line`}>
      {paragraph || emptyLineSpaceChar} {/* Use non-breaking space if paragraph is empty */}
    </p>
  ));
};
